import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBsuIYTtLmv-Dt8PkuYZSX9i4PNH3tpnLk",
  authDomain: "vacanza-system.firebaseapp.com",
  projectId: "vacanza-system",
  storageBucket: "vacanza-system.appspot.com",
  messagingSenderId: "444429214521",
  appId: "1:444429214521:web:461ca5c95fb30ea2d3bee8",
};

const app = initializeApp(firebaseConfig);

export const firebaseProjectId = firebaseConfig.projectId;
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west3");

export default app;
